import React from "react";

import Flex from "./base/flex";

const Section = ({
  children,
  justifyContent,
  alignItems,
  flexDirection,
  ...props
}) => {
  return (
    <Flex
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      backgroundPosition="center"
      justifyContent="center"
      alignItems="center"
      padding={["38px 28px 40px", "38px 32px 40px", "42px 32px 50px"]}
      {...props}
    >
      <Flex
        justifyContent={justifyContent}
        alignItems={alignItems}
        flexDirection={flexDirection}
        width="1200px"
        height="100%"
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default Section;
